/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Installed application on a host asset golden
 * @export
 * @interface InstalledApplicationDto
 */
export interface InstalledApplicationDto {
    /**
     * 
     * @type {string}
     * @memberof InstalledApplicationDto
     */
    applicationGoldenId?: string;
    /**
     * 
     * @type {string}
     * @memberof InstalledApplicationDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof InstalledApplicationDto
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof InstalledApplicationDto
     */
    publisher?: string;
    /**
     * 
     * @type {string}
     * @memberof InstalledApplicationDto
     */
    baselineState?: string;
    /**
     * 
     * @type {string}
     * @memberof InstalledApplicationDto
     */
    fileHash?: string;
    /**
     * 
     * @type {string}
     * @memberof InstalledApplicationDto
     */
    sourceSystem?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InstalledApplicationDto
     */
    sourceSystems?: Array<string>;
}

/**
 * Check if a given object implements the InstalledApplicationDto interface.
 */
export function instanceOfInstalledApplicationDto(value: object): value is InstalledApplicationDto {
    return true;
}

export function InstalledApplicationDtoFromJSON(json: any): InstalledApplicationDto {
    return InstalledApplicationDtoFromJSONTyped(json, false);
}

export function InstalledApplicationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstalledApplicationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationGoldenId': json['applicationGoldenId'] == null ? undefined : json['applicationGoldenId'],
        'name': json['name'] == null ? undefined : json['name'],
        'version': json['version'] == null ? undefined : json['version'],
        'publisher': json['publisher'] == null ? undefined : json['publisher'],
        'baselineState': json['baselineState'] == null ? undefined : json['baselineState'],
        'fileHash': json['fileHash'] == null ? undefined : json['fileHash'],
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
        'sourceSystems': json['sourceSystems'] == null ? undefined : json['sourceSystems'],
    };
}

export function InstalledApplicationDtoToJSON(json: any): InstalledApplicationDto {
    return InstalledApplicationDtoToJSONTyped(json, false);
}

export function InstalledApplicationDtoToJSONTyped(value?: InstalledApplicationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationGoldenId': value['applicationGoldenId'],
        'name': value['name'],
        'version': value['version'],
        'publisher': value['publisher'],
        'baselineState': value['baselineState'],
        'fileHash': value['fileHash'],
        'sourceSystem': value['sourceSystem'],
        'sourceSystems': value['sourceSystems'],
    };
}

